export class TextWidthCache {
  private readonly cache = new Map<string, number>();
  private readonly maxEntries: number;

  constructor(maxEntries = 1024) {
    this.maxEntries = Math.max(1, Math.floor(maxEntries));
  }

  get(
    font: string,
    text: string,
    measure: (value: string) => number
  ): number {
    const key = `${font}|${text}`;
    const cached = this.cache.get(key);
    if (cached != null) {
      return cached;
    }
    if (this.cache.size >= this.maxEntries) {
      this.cache.clear();
    }
    const width = measure(text);
    this.cache.set(key, width);
    return width;
  }

  clear(): void {
    this.cache.clear();
  }

  size(): number {
    return this.cache.size;
  }
}
